import { IBlocksExpandedState } from "../types";

export const defaultBlocksExpanded: IBlocksExpandedState = {
  premiseBlock: true,
  accountBlock: false,
  electricityBlock: false,
  gasLineBlock: false,
  gasBothBlock: false,
  gasMeterBlock: false,
  internetBlock: false,
  closeTransferBlock: false,
};
